import React from "react";
import ReturnOfGoodsFromVendorsGenericSkeleton from "./ReturnOfGoodsFromVendorsGenericSkeleton";

function ReturnOfGoodsFromVendorsDetailSkeleton() {
  return (
    <>
      <ReturnOfGoodsFromVendorsGenericSkeleton />
    </>
  );
}

export default ReturnOfGoodsFromVendorsDetailSkeleton;
